import { render, staticRenderFns } from "./SpreadList.vue?vue&type=template&id=05d05170&"
import script from "./SpreadList.vue?vue&type=script&lang=js&"
export * from "./SpreadList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports